export const DEVICES = ['mac', 'windows', 'iphone', 'android', 'linux'] as const;

export const DEVICE_LABELS: Record<(typeof DEVICES)[number], string> = {
  mac: 'Mac (macOS)',
  windows: 'PC (Windows)',
  iphone: 'iPhone (iOS)',
  android: 'Android',
  linux: 'PC (GNU Linux)',
} as const;
